/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostAIConfigTriggerPathParams = NonNullable<operations['postAIConfigTrigger']['parameters']['path']>;

export type PostAIConfigTriggerQueryParams = NonNullable<operations['postAIConfigTrigger']['parameters']['query']>;

export type PostAIConfigTriggerRequestBody = OperationRequestBodyContent<operations['postAIConfigTrigger']>;

export interface Input extends PostAIConfigTriggerPathParams {
  apiVersion?: string;
  query: PostAIConfigTriggerQueryParams;
  body: PostAIConfigTriggerRequestBody;
  header: NonNullable<operations['postAIConfigTrigger']['parameters']['header']>;
}

export async function postAIConfigTrigger(
  { apiVersion, body, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/ai-configs/{configKey}/triggers', {
    params: { path, query, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
